module.exports = __webpack_public_path__ + "img/key.dafac12f.svg";